module.exports = __webpack_public_path__ + "static/img/logo2023.caf1b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/img/logo2023.png
// module id = z1l7
// module chunks = 43